import { AuthLayout } from '../components/AuthLayout';
import SignupForm from './SignupForm';

const Signup = () => (
  <AuthLayout>
    <SignupForm />
  </AuthLayout>
);

export default Signup;
